<template>
	<div class="full-page-cover">
		<div class="blockforthat">
			<div class="top-part">
				<h2>Congradulation!</h2>
				<center>
                	<img src="/img/rocket.png" alt="" width="30%">
				</center>
			</div>
			<div class="center-part">
				<h4> Your payment of {{paymantAmountStripe}} USD has been received and added to your account. </h4>
			</div>
			<div class="bottom-part">
				<center>
					<button class="goBackButton" @click="goBack()">Back to Account Summary</button>
				</center>
			</div>
		</div>	
		
	</div>
</template>

<script>
	export default{
		name:'PaymentSuccess',
        components: {
            Payment: () => import("./PaymentGateway.vue"),
        },
      
		computed:{
			paymantAmountStripe(){
				return this.$store.state.payment.amount
			}
		},
		methods:{
			goBack(){
				// console.log(this.$router)
				this.$router.push({name:'company-admin-payment-gateway'})
			}
		}
	}
</script>


<style type="text/css">
	h2{
		font-size: 24.36px;
	}
	.full-page-cover{
		display: flex;
		justify-content: center;
		align-items: center;
		background: url('https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/img/vuexy-login-bg.04351a33.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}
	.blockforthat{
		width: 40%;
		background: white;
		border-radius: .5rem;
		box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
		padding: 10px;
	}
	.sidebar-container{
		/*display: none;*/
	}
	.top-part{
		display: grid;
		justify-content: center;
		align-items: center;
		text-align: center;
		margin-top: 10px;
	}
	.center-part{
		margin-top: 10px;
		text-align: center;
	}
	.goBackButton{
		margin-top: 10px;
		width: 95%;
		height: 50px;
		border: none;
		color: white;
		background: rgb(112,127,230);
		background: linear-gradient(97deg, rgba(112,127,230,1) 0%, rgba(139,137,240,1) 97%, rgba(244,225,240,1) 100%);
		border-radius: 10px;
		transition: .3s;
		outline: none;
	}
	.goBackButton:hover{
		width: 100%;
		/*background: rgb(112,127,230);*/
/*background: linear-gradient(270deg, rgba(112,127,230,1) 0%, rgba(139,137,240,1) 97%, rgba(244,225,240,1) 100%);*/
	}
</style>